import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ActivityIndicator,
  Alert,
} from "react-native";
import dateFormat from "dateformat";
import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import Cita from "../components/Cita";
import makeRequest from "../components/makeRequest";

const estilizarFecha = (fecha) => {
  const semana = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo",
  ];
  const mes = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];
  const horas =
    fecha.getHours() < 10 ? "0" + fecha.getHours() : fecha.getHours();
  const minutos =
    fecha.getMinutes() < 10 ? "0" + fecha.getMinutes() : fecha.getMinutes();
  return `${semana[fecha.getDay()]}, ${fecha.getDate()} de ${
    mes[fecha.getMonth()]
  } del ${fecha.getFullYear()} a las ${horas}:${minutos}`;
};
const tryDelete = (id) => {
  const request = async () => {
    const response = await makeRequest("citas/cancelar/" + id, "post");
    if (response[0] == 200) return true;
  };
  return request();
};

export default function (props) {
  const [loading, setLoading] = useState(true);
  const [citas, setCitas] = useState([]);
  const loadCitas = (id) => {
    const request = async () => {
      const response = await makeRequest("citas", "get");
      if (response[0] == 200) {
        setCitas(response[1]), setLoading(false);
      }
      setLoading(false);
    };
    request();
  };

  useEffect(() => {
    loadCitas(props.route.params.userInfo._id);
  }, []);
  const usuario = props.route.params.userInfo
    ? props.route.params.userInfo.nombre +
      " " +
      props.route.params.userInfo.apellido
    : "";
  const eliminarCita = (id, instalacion, fecha) => {
    if (tryDelete(id)) setCitas(citas.filter((cita) => cita._id != id));
  };
  return (
    <BackgroundUser scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      {!loading ? (
        <>
          {citas.length !== 0 &&
            citas.map((e) => {
              return (
                <Cita
                  onChange={() =>
                    props.navigation.navigate("qrcita", { text: e._id })
                  }
                  onPress={() =>
                    eliminarCita(
                      e._id,
                      props.route.params.instalaciones.filter(
                        (y) => y._id == e.instalacion
                      )[0].nombre,
                      estilizarFecha(new Date(e.inicio))
                    )
                  }
                  key={e._id}
                  id={e._id}
                  titulo={
                    props.route.params.instalaciones.filter(
                      (y) => y._id == e.instalacion
                    )[0].nombre
                  }
                  fecha={
                    estilizarFecha(new Date(e.inicio)) +
                    " hasta las" +
                    dateFormat(new Date(e.final), " HH:MM")
                  }
                  final={""}
                  usuario={usuario}
                  numAdultos={e.adultos}
                  numNinos={e.ninos}></Cita>
              );
            })}
          {citas.length === 0 && (
            <Title
              style={{ marginTop: "auto", marginBottom: "auto", fontSize: 16 }}>
              No tiene ninguna cita pendiente
            </Title>
          )}
        </>
      ) : (
        <ActivityIndicator
          size='large'
          color='rgba(255,255,255, 0.6)'
          style={{ marginTop: 100 }}
        />
      )}
      <View style={{ height: 100 }}></View>
    </BackgroundUser>
  );
}
